import axios from "axios";
import authHeader from "./auth-header";

const API_URL = `${process.env.VUE_APP_API_ENDPOINT}/api/test/`;
const API_BASE_URL = `${process.env.VUE_APP_API_ENDPOINT}/api/user/`;

class UserService {
  getPublicContent() {
    return axios.get(API_URL + "all");
  }

  getUserBoard() {
    return axios.get(API_URL + "user", { headers: authHeader() });
  }

  getModeratorBoard() {
    return axios.get(API_URL + "mod", { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(API_URL + "admin", { headers: authHeader() });
  }

  async findByIndex(lte, gte) {
    const result = await axios.get(API_BASE_URL + `findbyindex/${lte}/${gte}`, {
      headers: authHeader(),
    });
    return result;
  }

  async setToken(token) {
    const result = await axios.post(
      API_BASE_URL + `token`,
      { token: token },
      {
        headers: authHeader(),
      },
    );
    return result;
  }

  async findByDB(maintionID, page) {
    const result = await axios.get(
      API_BASE_URL + `findbydb?mansion=${maintionID}&page=${page}`,
      {
        headers: authHeader(),
      },
    );
    return result;
  }

  async findByID(_id) {
    const result = await axios.get(API_BASE_URL + `find/${_id}`, {
      headers: authHeader(),
    });
    return result;
  }

  async edit(user) {
    console.log("edit");
    console.log(user);
    return await axios.post(
      API_BASE_URL + `${user._id}`,
      {
        loginID: user.loginID,
        username: user.username,
        email: user.email,
        mansion: user.mansion,
        roomNo: user.roomNo,
        role: user.role,
      },
      { headers: authHeader() },
    );
  }

  async remove(_id) {
    console.log(`remove=${_id}`);
    return await axios.delete(API_BASE_URL + `${_id}`, {
      headers: authHeader(),
    });
  }

  async messaging(title, body, tokens, clickAction) {
    console.log(`messagin`);
    const paload = {
      title: title,
      body: body,
      tokens: tokens,
      clickAction: clickAction,
    };
    return await axios.post(API_BASE_URL + `messaging`, paload, {
      headers: authHeader(),
    });
  }

  async sendmail(subject, body, emails) {
    console.log(`sendmail`);
    const paload = { subject: subject, body: body, emails: emails };
    return await axios.post(API_BASE_URL + `sendmail`, paload, {
      headers: authHeader(),
    });
  }
}

export default new UserService();
